module.exports = __webpack_public_path__ + "img/replenishment_setting.fc1b8c9b.svg";